"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var slugsFactory = function slugsFactory(items) {
  return items.map(function (item) {
    var _category$fields, _parent$fields, _subCategory$fields, _subLevel$fields;
    var _item$fields = item === null || item === void 0 ? void 0 : item.fields,
      category = _item$fields.category,
      subCategory = _item$fields.subCategory,
      parent = _item$fields.parent,
      subLevel = _item$fields.subLevel,
      slug = _item$fields.slug;
    var allSlugs = [(category === null || category === void 0 ? void 0 : (_category$fields = category.fields) === null || _category$fields === void 0 ? void 0 : _category$fields.slug) || (parent === null || parent === void 0 ? void 0 : (_parent$fields = parent.fields) === null || _parent$fields === void 0 ? void 0 : _parent$fields.slug), (subCategory === null || subCategory === void 0 ? void 0 : (_subCategory$fields = subCategory.fields) === null || _subCategory$fields === void 0 ? void 0 : _subCategory$fields.slug) || (subLevel === null || subLevel === void 0 ? void 0 : (_subLevel$fields = subLevel.fields) === null || _subLevel$fields === void 0 ? void 0 : _subLevel$fields.slug), slug];
    return allSlugs.filter(function (s) {
      return !!s;
    });
  });
};
var _default = slugsFactory;
exports["default"] = _default;